import { get, last } from 'lodash'
import { connect } from 'react-redux'
import actions, { withProductLine } from '../../actions/GenericBenefitsSets'
import historyActions from '../../actions/BenefitsSetFieldHistories'
import BenefitsSetShow from '../BenefitsSet/BenefitsSetShow'
import HospitalIndemnityBenefitsSetComponent from './HospitalIndemnityBenefitsSetComponent'

const mapStateToProps = (state) => {
  const slice = state.genericBenefitsSets.show

  const configuration = state.login.session.configuration.benefits
  const historySlice = state.benefitsSetFieldHistory.index
  return {
    benefitsSet: slice.attributes,
    rejection: last(get(slice.attributes, 'rejections', [])),
    configuration,
    benefitsSetFieldHistory: historySlice.records,
    productLine: 'Hospital Indemnity',
    benefitsSetComponent: HospitalIndemnityBenefitsSetComponent
  }
}

const mapDispatchToProps = {
  show: withProductLine('hospital_indemnity', actions.show.main),
  reset: actions.show.reset,
  history: historyActions.index.main,
  resetHistory: historyActions.index.reset
}

export default connect(mapStateToProps, mapDispatchToProps)(BenefitsSetShow)
